import React from 'react'
import { Box, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'

interface ComparisonBarChartNoDataProps {
  title: string
  message: string
  cardSx: SxProps<Theme>
  glowSx: SxProps<Theme>
}

const ComparisonBarChartNoData: React.FC<ComparisonBarChartNoDataProps> = ({ title, message, cardSx, glowSx }) => {
  return (
    <Box sx={cardSx}>
      <Box sx={glowSx} />
      <Typography sx={{ ...INTERAX_TYPOGRAPHY.headline5, color: INTERAX_COLORS.white, zIndex: 1, textAlign: 'center' }}>
        {title}
      </Typography>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1 }}>
        <Typography sx={{ ...INTERAX_TYPOGRAPHY.body2, color: INTERAX_COLORS.thunderGrey, textAlign: 'center' }}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

export default ComparisonBarChartNoData
